module.exports = __webpack_public_path__ + "assets/img/6ac880acb5839c93c4bb430ead42decc.svg";